import { useNavigate } from "react-router-dom";
import { useState, useEffect } from "react";

function NavBar(){
    const navigate = useNavigate();
    const [menuOpen, setMenuOpen] = useState(false);
    const [logo, setLogo] = useState("/img/osseo-logo.png");

    useEffect(() => {
        const updateLogo = () => {
            if (window.innerWidth <= 440) {
                setLogo("/img/hamburger.png");
            } else {
                setLogo("/img/osseo-logo.png");
            }
        };

        updateLogo();
        window.addEventListener("resize", updateLogo);

        return () => window.removeEventListener("resize", updateLogo);
    }, []);

    const toggleMenu = () => {
        const isMobile = window.innerWidth < 440;
        if(isMobile){
            if(menuOpen){
                navigate('/');
            } else {
                setMenuOpen(true);
            }
        } else {
            navigate('/');
        }
        
    };

    return(
        <>
        <nav className='navbar'>
            <img className='nav-logo' src={logo} style={{position: 'absolute'}} onClick={toggleMenu}/>
            <div className='nav-item' onClick={() => navigate('/')}>
                <h3>Home</h3>
            </div>
            <div className='nav-item'>
                <h3 onClick={() => navigate('/gallery')}>Solutions</h3>
                <ul className='nav-dropdown' style={{left: '-2.75rem'}}>
                    <li onClick={() => navigate('/gallery/allceramic')}>All Ceramic</li>
                    <li onClick={() => navigate('/gallery/pfm')}>PFM</li>
                    <li onClick={() => navigate('/gallery/implants')}>Implants</li>
                    <li onClick={() => navigate('/gallery/fullgold')}>Full Gold</li>
                    <li onClick={() => navigate('/gallery/dprinting')}>3D Printing</li>
                    <li onClick={() => navigate('/gallery/milling')}>Milling</li>
                    <li onClick={() => navigate('/gallery/longtermtemps')}>Long Term Temps</li>
                    <li onClick={() => navigate('/gallery/fullarchzirconia')}>Implant Supported Full Arch Zirconia</li>
                    <li onClick={() => navigate('/tech-info')}>Tech Info</li>
                </ul>
            </div>
            <div className='nav-item' onClick={() => navigate('/about')}>
                <h3>About Us</h3>
            </div>
            <div className='nav-item' onClick={() => navigate('/contact')}>
                <h3>Contact</h3>
            </div>
            <div className='nav-item'>
                <h3>Send a Case</h3>
                <ul className='nav-dropdown' style={{left: '-2.25rem'}}>
                    <li onClick={() => navigate('/contact')}>Phone Us to Pick Up</li>
                    <li onClick={() => navigate('/send-digital-files')}>Send Digital Files</li>
                </ul>
            </div>
        </nav>

        {menuOpen && (
            <div className='mobile-menu'>
                <p onClick={() => navigate('/')}>Home</p>
                <p onClick={() => navigate('/gallery')}>Solutions</p>
                <p onClick={() => navigate('/about')}>About Us</p>
                <p onClick={() => navigate('/contact')}>Contact</p>
                <p onClick={() => navigate('/send-digital-files')}>Send Digital Files</p>
            </div>
        )}
        </>
    )
}
export default NavBar;